module.exports = __webpack_public_path__ + "static/media/mike-3-250x251.e24300f6.png";